import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── Register audio-caching service worker for offline playback ──
// Every audio the user plays is silently cached. Subsequent plays are
// served instantly from Cache Storage — no backend call, no TTS call,
// works in airplane mode.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/audio-sw.js", { scope: "/" })
      .catch((err) => console.warn("audio-sw registration failed:", err));
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
